import { AmlLimit } from '@shared/interfaces/aml-limit';
import { Observable } from 'rxjs';

export const AML_LIMIT_REPOSITORY = 'AmlLimitsRepository';

export interface AmlLimitsRepository {
  getItems(): Observable<any>;

  add(limit: AmlLimit): Observable<any>;

  edit(limit: AmlLimit): Observable<any>;

  delete(item: any): Observable<any>;

  segmentWithoutAmlLimits(): Observable<any>;
}
